import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
import athenaconfig from './athen-exports'
const __PASSWORD = "P@ssw0rd__"
Amplify.configure(awsconfig);
console.log(Amplify)
let appSyncClient = null
let athenaAppsyncClient = null
const getAuthToken = async (token)=>{
    let jwtToken = token;
    try {
        let session = await Auth.currentSession()
        jwtToken = session.getIdToken().getJwtToken()
    } catch (error) {
        console.log(error);
    }
    if (!jwtToken) {
        throw Error("No user session Found")
    }
    return jwtToken;
}
const initAthenaAppSyncClient = async (token) => {
    athenaAppsyncClient = new AWSAppSyncClient({
        disableOffline: true,
        url: athenaconfig.ApiUrl,
        region: athenaconfig.Region,
        auth: {
            type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS, // or type: awsconfig.aws_appsync_authenticationType,
            // apiKey: awsconfig.aws_appsync_apiKey,
            jwtToken: async () => await getAuthToken(token)
        }
    });
    console.log("appclient successfully initialized")
    return athenaAppsyncClient
}

const initAppSyncClient = async (token = "") => {
    try {
        let athenaclient = await initAthenaAppSyncClient(token)
        appSyncClient = new AWSAppSyncClient({
            disableOffline: true,
            url: awsconfig.aws_appsync_graphqlEndpoint,
            region: awsconfig.aws_appsync_region,
            auth: {
                type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS, // or type: awsconfig.aws_appsync_authenticationType,
                // apiKey: awsconfig.aws_appsync_apiKey,
                jwtToken:  async () => await getAuthToken(token)
            }
        });
        console.log("appclient successfully initialized")
        return appSyncClient
    } catch (error) {
        console.log(error);
    }
}
const enableTwoFactorAuth = async (user) => {
    return await Auth.enableSMS(user)
}
const signInCognitoUserwithPhone = async (mobileNumber, countryCode = "+91") => {
    let username = mobileNumber;
    if (countryCode !== "+91") {
        // add country code to username for non indian users
        username = countryCode.split("+")[1].concat(mobileNumber)
    }
    const signInReponse = await Auth.signIn(username)
    return signInReponse
}
const signUpUserWithCognito = async (mobileNumber, countryCode = "+91") => {
    let username = mobileNumber;
    if (countryCode !== "+91") {
        // add country code to username for non indian users
        username = countryCode.split("+")[1].concat(mobileNumber)
    }
    const signupResponse = await Auth.signUp({
        username,
        password: __PASSWORD, "attributes": {
            phone_number: `${countryCode}${mobileNumber}`
        },
        validationData: []
    })
    let user = signupResponse.user
    return user
}
const onUserSignInConfirm = async (phone, code) => {
    try {
        let user = await Auth.confirmSignUp(phone, code);
        user = await Auth.signIn(phone, __PASSWORD)
        return user
    } catch (error) {
        console.log(error)
        throw new Error("OTP validation failed")
    }

};
const signInUserWithCognito = async (username) => {
    const user = await Auth.signIn(username);
    return user;
}
const signInCognitoUserWithOTP = async (user, code) => {
    try {
        // const signedin_user = await Auth.confirmSignIn(user,code,user.challengeName);
        // return signedin_user;
        const signedin_user = await Auth.sendCustomChallengeAnswer(user, code);
        return signedin_user;

    } catch (error) {
        console.log(error)
        if (error.code === "UserNotConfirmedException") {
            throw new Error("Seems like you did not finish your registration. Try registering again.");
        }
        throw new Error("OTP validation failed")
    }
}
const signOutUserWithCognito = async () => {
    await Auth.signOut();
}

const getAppSyncClient = async () => {
    if (appSyncClient) return appSyncClient
    return await initAppSyncClient()
}

const getAthenaAppsyncClient = async () => {
    if (athenaAppsyncClient) return athenaAppsyncClient
    return await initAthenaAppSyncClient()
}

const getAuthincatedCognitoSession = async () => {
    return await Auth.currentAuthenticatedUser()
}
export {
    signInUserWithCognito,
    signOutUserWithCognito,
    signUpUserWithCognito,
    initAppSyncClient,
    getAthenaAppsyncClient,
    getAppSyncClient,
    getAuthincatedCognitoSession,
    enableTwoFactorAuth,
    onUserSignInConfirm,
    signInCognitoUserwithPhone,
    signInCognitoUserWithOTP
};